import { useState, useEffect } from 'react';
import {
  Grid, Button, Typography, Box, Radio, RadioGroup, FormControlLabel, Paper, TextField, Stepper, Step, StepLabel, CircularProgress
} from '@mui/material';
import { getListAPI as getAudianceList } from 'components/audience/AudienceAPI';
import { useSelector } from 'react-redux';
import { testEmailCampaignAPI } from 'api/OmsFactoryopsWebServices';

const steps = ['Select Template & Audience', 'Preview Campaign', 'Success'];

export default function TestCampaignActionImpl() {
  const [activeStep, setActiveStep] = useState(1);
  const [audianceList, setAudienceList] = useState([]);
  const [selectedAudience, setSelectedAudience] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [apiError, setApiError] = useState('');
  const [sending, setSending] = useState(false);
  const { templateObj } = useSelector((state) => state.manufslice.templateDashboard);
  const { userprofileInfo } = useSelector((state) => state.headerslice);

  useEffect(() => {
    getAudianceList(setAudienceList, () => {});
  }, []);

  useEffect(() => {
    setApiError('');
  }, [activeStep, selectedAudience]);

  const filteredAudience = audianceList.filter(aud =>
    aud.email.toLowerCase().includes(searchEmail.toLowerCase())
  );

  const handleNext = () => setActiveStep(prev => prev + 1);
  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleSendCampaign = async () => {
    setApiError('');
    setSending(true);
    const payload = {
      templateId: templateObj?.id,
      email: userprofileInfo?.email,
      audienceName: userprofileInfo.username,
    };
    testEmailCampaignAPI(
      payload,
      (apiResponse) => {
        setSending(false);
        setActiveStep(prev => prev + 1); // Move to next step on success
      },
      (error) => {
        setSending(false);
        setApiError(error.message || 'Failed to send campaign');
      }
    );
  };

  return (
    <Box sx={{ width: '100%', p: { xs: 1, sm: 2 } }}>
      {/* <Stepper activeStep={activeStep} sx={{ mb: { xs: 2, sm: 4 } }}>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper> */}

      {activeStep === 0 && (
        <Grid container spacing={2} sx={{ position: 'relative' }}>
          <Grid item lg={6} md={6} sm={6} xs={12} >
            <Paper sx={{ p: { xs: 1, sm: 2 }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {templateObj?.assetpath ? (
                <Box sx={{ width: '100%', maxWidth: 400 }}>
                  <img
                    src={templateObj.assetpath}
                    alt={templateObj.title}
                    style={{
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                      borderRadius: 8,
                      marginBottom: 8
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{ width: 120, height: 120, bgcolor: '#eee', borderRadius: 8, mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography>No Image</Typography>
                </Box>
              )}
              <Typography variant="subtitle1">{templateObj?.title}</Typography>
            </Paper>
          </Grid>
          <Grid item lg={6} md={6} sm={6}  xs={12} >
            <Paper sx={{ p: { xs: 1, sm: 2 } }}>
              <Typography variant="h6">Select Audience</Typography>
              <TextField
                label="Search by Email"
                variant="outlined"
                size="small"
                fullWidth
                sx={{ mb: 2 }}
                value={searchEmail}
                onChange={e => setSearchEmail(e.target.value)}
              />
              <RadioGroup
                value={selectedAudience}
                onChange={e => setSelectedAudience(e.target.value)}
              >
                {filteredAudience.map(aud => (
                  <FormControlLabel
                    key={aud.id}
                    value={aud.id}
                    control={<Radio />}
                    label={aud.email}
                  />
                ))}
              </RadioGroup>
            </Paper>
          </Grid>
          <Box
            sx={{
              position: 'absolute',
              right: 24,
              bottom: 16
            }}
          >
            <Button
              variant="contained"
              disabled={!selectedAudience}
              onClick={handleNext}
            >
              Next
            </Button>
          </Box>
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid container justifyContent="center">
          <Grid item lg={8} xs={12} md={10} >
            <Box sx={{ }}>
              <Typography variant="h6" gutterBottom>
                Test Campaign would be sent to - <span><strong>{userprofileInfo.email}</strong></span>
              </Typography>
              <Paper
                sx={{
                  p: { xs: 1, sm: 2 },
                  mb: 2,
                  maxHeight: { lg: '65vh', md: '65vh', sm: '60vh', xs: '70vh' },
                  maxWidth: '100%',
                  overflowY: 'auto',
                  overflowX: 'auto',
                  bgcolor: '#fafafa'
                }}
              >
                <Typography
                  sx={{ mt: 2 }}
                  dangerouslySetInnerHTML={{
                    __html: templateObj?.campaigntext
                      ? String(templateObj.campaigntext)
                          .replace(/{{NAME}}/g, audianceList.find(a => a.id === selectedAudience)?.name || '')
                          .replace(
                            /{{IMAGE}}/g,
                            templateObj?.assetpath
                              ? `<img src="${templateObj.assetpath}" alt="Image" style="width:75vw;max-width:75vw;height:auto;object-fit:cover;border-radius:8px;margin-bottom:8px;" />`
                              : ''
                          )
                          .replace(/(\r\n|\r|\n)/g, '<br/>')
                      : ''
                  }}
                />
              </Paper>
              <Grid container justifyContent="flex-end" alignItems="center" sx={{ mt: 2 }}>
                <Grid item>
                  {apiError && (
                    <Typography color="error" sx={{ mr: 2 }}>
                      {apiError}
                    </Typography>
                  )}
                </Grid>
                <Grid item>
                  {sending ? (
                    <CircularProgress size={32} />
                  ) : (
                    <Button variant="contained" onClick={handleSendCampaign}>Send Campaign</Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}

      {activeStep === 2 && (
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8} lg={6}>
            <Box sx={{ p: { xs: 2, sm: 3 }, textAlign: 'center' }}>
              <Typography variant="h5" color="success.main" gutterBottom>
                Campaign sent successfully!
              </Typography>
              <Typography variant="body1">Your campaign has been delivered to the selected audience.</Typography>
              <Button sx={{ mt: 2 }} variant="outlined" onClick={() => setActiveStep(1)}>Start New</Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}